import React from 'react';
import { IWidgetComponentOptionProps } from '../../../../IWidgetType';
import { IComponentOptions } from '../../../../WidgetOptionLogic';
import { IMultiSelectWidget } from '../../multi-select/IMultiSelectWidget';
import { ISingleSelectWidget } from '../../single-select';
import { IWidgetParsedProps } from '../util/getWidgetProps';
import { optionsOrPreviewOptions } from './optionsOrPreviewOptions';
import { OptionsGroup } from './style/OptionsGroup';

export interface ISelectListOptionProps {
  widget: IMultiSelectWidget | ISingleSelectWidget;
  options: IComponentOptions;
  OptionComponent: React.ComponentType<IWidgetComponentOptionProps<any>>;

  widgetOptions: IWidgetParsedProps;

  readonly?: boolean;
}

/**
 * Gestisce in maniera centralizzata la visualizzazione delle option di un widget di tipo Select (singola/multipla)
 * in formato lista di checkbox o radio.
 */
export function SelectListOption(props: ISelectListOptionProps) {
  const { options, widgetOptions, OptionComponent, widget } = props;

  // Deseleziona automaticamente il valore se non è più presente tra le option
  // const { visibleOptionsMap, enabledOptionsMap } =
  //   useDeselectInvalidOptionEffect(widgetOptions, options);

  if (options.type === 'flat') {
    return (
      <>
        {optionsOrPreviewOptions(options.values, widgetOptions.preview).map(
          option => (
            // Use optionComponent as react component
            <OptionComponent
              readonly={props.readonly}
              option={option}
              key={option.value}
              widget={widget}
              name={option.value}
              groupName={widgetOptions.name}
              preview={widgetOptions.preview}
            />
          ),
        )}
      </>
    );
  }

  return (
    <>
      {options.options.map((group, index) => (
        <OptionsGroup
          key={index}
          label={group.label}
          vertical={widget.layout?.direction === 'vertical'}
          labelLikeText={widget.layout?.separator === 'text'}
          widgetHideLabel={widget.layout?.hideLabel}
        >
          {group.options?.map((option, i) => (
            <OptionComponent
              readonly={props.readonly}
              option={option}
              key={option.value}
              widget={widget}
              name={option.value}
              groupName={widgetOptions.name}
            />
          ))}
        </OptionsGroup>
      ))}
    </>
  );
}
